/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLibraryBooks = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 22v-4h4V2H6v4H2v16zm2-6h-2V6H8V4h12zm-4 4H4V8h12zm-2-8v-2H6v2zm0 3v-2H6v2zm-4 3v-2H6v2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLibraryBooks as LibraryBooks };
